export default {"src":"/_next/static/media/twilio-account-credentials.b27c28a1.gif","height":682,"width":1200,"blurWidth":0,"blurHeight":0};